
import React, {Component} from 'react'
import { connect } from 'react-redux'
import SettingsProperty from './components/Settings/SettingsProperty'
import SettingsStep from './components/Settings/SettingsStep'

import {
  setTitle
} from 'common/redux/root'

import {
  savePropertyCategories, updatePropertyCategories
} from 'manager/redux/settings'

const mapDispatchToProps = dispatch => ({
    dispatch
})

class SettingsPropertyContainer extends Component {

  componentWillMount() {
    this.props.dispatch(setTitle("My Property Types"))
  }

  handleSubmit = cb => {
    const { dispatch, settings } = this.props
    if (this.isValid()) {
      dispatch(savePropertyCategories(settings.property_categories)).then(cb)
    }
  }

  handleSelect = (key, enabled) => {
    this.props.dispatch(updatePropertyCategories(key, enabled))
  }

  isValid = () => {
    const { settings } = this.props
    return !!settings.property_categories
  }

  render() {
    return <SettingsStep shouldDisableSubmit={!this.isValid()} onSubmit={this.handleSubmit} {...this.props}>
      <SettingsProperty onSelect={this.handleSelect} {...this.props} />
    </SettingsStep>
  }

}

export default connect((state) => ({ settings: state.settings }), mapDispatchToProps)(SettingsPropertyContainer)
